import { Component, EventEmitter, Input, Output, OnInit, SimpleChanges, OnChanges } from '@angular/core';
import { GraphDataEthnicity } from '../../backend-response-models/calc-enums.helper';
import { Dataset } from '../../shared/shared-enums/enum-helper';
import { DropdownChangeEvent } from 'primeng/dropdown';
import { TranslatePipe } from '../../languages/translate.pipe';
import { DropdownModule } from 'primeng/dropdown';
import { COMMON_IMPORTS } from '../../common-imports';
import { TableModule } from 'primeng/table';

@Component({
  selector: 'app-comparative-axial-data',
  standalone: true,
  imports: [DropdownModule, TableModule, ...COMMON_IMPORTS],
  templateUrl: './comparative-axial-data.component.html',
  styleUrl: './comparative-axial-data.component.css',
})
export class ComparativeAxialDataComponent implements OnInit, OnChanges {
  @Input()
  ethnicity?: GraphDataEthnicity;

  @Output()
  ethnicityChanged = new EventEmitter<GraphDataEthnicity>();

  public ethnicityDict: Record<GraphDataEthnicity, string> = {
    [GraphDataEthnicity.WESTERN]: 'WESTERN_DATA_CHOICE',
    [GraphDataEthnicity.EAST_ASIAN]: 'EAST_ASIAN_DATA_CHOICE',
  };
  public dataSets: Dataset[] = [];
  public selectedDataset?: Dataset;

  private axialLengthDataWestern: AxialLengthRow[] = [
    { age: '6', expectedEyeGrowth: '0.40 - 0.50' },
    { age: '7', expectedEyeGrowth: '0.37 - 0.44' },
    { age: '8', expectedEyeGrowth: '0.33 - 0.38' },
    { age: '9', expectedEyeGrowth: '0.30 - 0.33' },
    { age: '10', expectedEyeGrowth: '0.26 - 0.28' },
    { age: '11', expectedEyeGrowth: '0.23 - 0.24' },
    { age: '12', expectedEyeGrowth: '0.19 - 0.20' },
    { age: '13', expectedEyeGrowth: '0.16 - 0.17' },
    { age: '14', expectedEyeGrowth: '0.12 - 0.14' },
    { age: '15', expectedEyeGrowth: '0.09 - 0.12' },
    { age: '16', expectedEyeGrowth: '0.05 - 0.11' },
  ];
  private axialLengthDataEastern: AxialLengthRow[] = [
    { age: '6', expectedEyeGrowth: '0.56 - 0.70' },
    { age: '7', expectedEyeGrowth: '0.51 - 0.61' },
    { age: '8', expectedEyeGrowth: '0.46 - 0.53' },
    { age: '9', expectedEyeGrowth: '0.41 - 0.45' },
    { age: '10', expectedEyeGrowth: '0.36 - 0.38' },
    { age: '11', expectedEyeGrowth: '0.31 - 0.32' },
    { age: '12', expectedEyeGrowth: '0.26 - 0.27' },
    { age: '13', expectedEyeGrowth: '0.21 - 0.23' },
    { age: '14', expectedEyeGrowth: '0.16 - 0.19' },
    { age: '15', expectedEyeGrowth: '0.12 - 0.16' },
    { age: '16', expectedEyeGrowth: '0.07 - 0.14' },
  ];

  public selectedAxialLengthData: AxialLengthRow[] = [];
  public studyReference = '';

  constructor(private translatePipe: TranslatePipe) {}

  ngOnInit(): void {
    if (!this.ethnicity) {
      this.ethnicity = GraphDataEthnicity.WESTERN;
    }
    this.refreshAll();
  }

  private addDataSets() {
    this.dataSets = [
      {
        label: this.translatePipe.transform('WESTERN_DATA_CHOICE'),
        value: GraphDataEthnicity.WESTERN,
      },
      {
        label: this.translatePipe.transform('EAST_ASIAN_DATA_CHOICE'),
        value: GraphDataEthnicity.EAST_ASIAN,
      },
    ];
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.refreshAll();
  }

  private refreshAll() {
    this.addDataSets();
    this.selectedDataset = this.dataSets.find(d => d.value === (this.ethnicity ?? GraphDataEthnicity.WESTERN));

    const ethnicitySelected = this.selectedDataset?.value;
    this.selectedAxialLengthData =
      ethnicitySelected === GraphDataEthnicity.WESTERN ? this.axialLengthDataWestern : this.axialLengthDataEastern;

    const studyReferenceKey =
      ethnicitySelected === GraphDataEthnicity.WESTERN ? 'COMPARATIVE_DATA_STUDY_REFRENCE_1' : 'COMPARATIVE_DATA_STUDY_REFRENCE_2';

    this.studyReference = this.translatePipe.transform(studyReferenceKey);
  }

  onDatasetChanged(event: DropdownChangeEvent) {
    this.ethnicity = event.value.value;
    this.selectedDataset = event.value;
    this.refreshAll();
    this.ethnicityChanged.emit(this.ethnicity);
  }
}

export interface AxialLengthRow {
  age: string;
  expectedEyeGrowth: string;
}
